import React from 'react';
import Landing from 'views/scenes/caregiver_screening/CaregiverApplicationLanding';

const CaregiverApplicationLanding = (props) => {
  return (
    <Landing {...props}/>
  );
};

CaregiverApplicationLanding.propTypes = {
};

export default React.memo(CaregiverApplicationLanding);
